export default __webpack_public_path__ + "static/media/share-person.97b0e4b2.svg";